import React from 'react';
import { Box, Typography } from '@mui/material';
import AutoModeIcon from '@mui/icons-material/AutoMode';
import { useTranslation } from 'react-i18next';

const Loading = () => {
    const { t } = useTranslation();
    return (
        <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '50vh',
        }}
        >
        <AutoModeIcon
            sx={{
            color: '#3498db',
            fontSize: '60px',
            animation: 'spin 1.2s linear infinite'
            }}
        />
        <Typography
            variant="h6"
            sx={{
            marginTop: '16px',
            fontWeight: 'bold',
            color: '#000',
            }}
        >
            {t("main.ativacao")}
        </Typography>
        <Typography
            variant="body2"
            sx={{
            marginTop: '8px',
            textAlign: 'center'
            }}
        >
             {t("main.ativacao-mensagem")}
        </Typography>

        <style>
            {`
            @keyframes spin {
                0% {
                transform: rotate(0deg);
                }
                100% {
                transform: rotate(360deg);
                }
            }
            `}
        </style>
        </Box>
    );
};

export default Loading;
